import React, { useEffect } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import { RouteBuilder } from ".";
import { useAppSelector } from "state/hooks";
import { Toast } from "components";
import { ProtectedRoute } from "./protectedRoute";
import { UnprotectedRoute } from "./unprotectedRoute";
import ReactGA from "react-ga4";

/**
 * MAIN ROUTER COMPONENT
 *
 * ===============================================
 *
 * This component houses all routes and their respective layouts.
 * To add a route navigate to the route builder and add to the existing list.
 *
 *
 */

const MainRouter: React.FC = () => {
  const { toast } = useAppSelector((state) => state);
  const { pathname } = useLocation();

  ReactGA.initialize("G-BG33ERT3RS", {
    testMode: window.location.hostname !== "precisionmatch.ai",
  });

  useEffect(() => {
    // Send pageview with a custom path
    ReactGA.send({
      hitType: "pageview",
      page: pathname,
      title: pathname,
    });
  }, [pathname]);

  return (
    <>
      <Toast {...toast} />
      <ScrollToTop />
      <Routes>
        {RouteBuilder?.length > 0 &&
          RouteBuilder.map((item, idx) => {
            const { Element, path, caseSensitive, Layout, props, isProtected } =
              item;
            // Checks if a layout exists or not
            const PageComponent = Layout ? (
              <Layout {...props}>
                <Element />
              </Layout>
            ) : (
              <Element />
            );

            return (
              <Route
                key={idx}
                path={path}
                element={
                  isProtected ? (
                    <ProtectedRoute>{PageComponent}</ProtectedRoute>
                  ) : (
                    <UnprotectedRoute>{PageComponent}</UnprotectedRoute>
                  )
                }
                caseSensitive={caseSensitive}
              />
            );
          })}
      </Routes>
    </>
  );
};

const ScrollToTop: React.FC = () => {
  const { pathname, search } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname, search]);

  return null;
};

export { MainRouter };
